<template>
  <v-dialog v-model="dialogModel" max-width="760">
    <v-card>
      <v-card-title class="text-h6 py-4">
        {{ title }}
      </v-card-title>
      <v-card-text class="pt-0">
        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.label"
              :label="$t('ncrm.contracts.itemFields.dialog.fields.label')"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="form.field_type"
              :items="fieldTypeOptions"
              item-title="label"
              item-value="value"
              :menu-props="selectMenuProps"
              :label="$t('ncrm.contracts.itemFields.dialog.fields.type')"
            >
              <template #item="{ props, item }">
                <v-list-item v-bind="props">
                  <template #prepend>
                    <v-icon size="18">{{ item.raw.icon }}</v-icon>
                  </template>
                </v-list-item>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="8">
            <v-text-field
              v-model="form.help_text"
              :label="$t('ncrm.contracts.itemFields.dialog.fields.helpText')"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="form.sort_order"
              type="number"
              min="1"
              :label="$t('ncrm.contracts.itemFields.dialog.fields.sortOrder')"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-switch
              v-model="form.is_required"
              color="primary"
              inset
              :label="$t('ncrm.contracts.itemFields.dialog.fields.isRequired')"
            />
          </v-col>
          <v-col v-if="mode === 'create'" cols="12" md="6">
            <v-switch
              v-model="form.save_as_template"
              color="primary"
              inset
              :label="$t('ncrm.contracts.itemFields.dialog.fields.saveAsTemplate')"
            />
          </v-col>
          <v-col v-if="form.field_type === 'select'" cols="12">
            <v-combobox
              v-model="form.option_labels"
              multiple
              chips
              closable-chips
              clearable
              :menu-props="selectMenuProps"
              :label="$t('ncrm.contracts.itemFields.dialog.fields.options')"
            />
          </v-col>
          <v-col cols="12">
            <div class="text-caption text-medium-emphasis mb-2">
              {{ $t("ncrm.contracts.itemFields.dialog.fields.initialValue") }}
            </div>
            <NcrmContractItemFieldValueInput
              v-model="form.value"
              :field-type="form.field_type"
              :label="$t('ncrm.contracts.itemFields.valueLabel')"
              :checkbox-label="$t('ncrm.contracts.itemFields.checkboxLabel')"
              :select-options="selectOptions"
              :menu-props="selectMenuProps"
              :rows="3"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-6 pb-4">
        <v-spacer />
        <v-btn variant="text" :disabled="loading" @click="dialogModel = false">
          {{ $t("app.actions.cancel") }}
        </v-btn>
        <v-btn
          color="primary"
          variant="elevated"
          :loading="loading"
          :disabled="!canSubmit"
          @click="$emit('submit')"
        >
          {{ submitLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import NcrmContractItemFieldValueInput from "./NcrmContractItemFieldValueInput.vue";

export default {
  name: "NcrmContractItemFieldDialog",
  components: {
    NcrmContractItemFieldValueInput,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "create",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    canSubmit: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    fieldTypeOptions: {
      type: Array,
      default: () => [],
    },
    selectMenuProps: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["update:modelValue", "submit"],
  computed: {
    dialogModel: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    title() {
      return this.mode === "edit"
        ? this.$t("ncrm.contracts.itemFields.dialog.editTitle")
        : this.$t("ncrm.contracts.itemFields.dialog.createTitle");
    },
    submitLabel() {
      return this.mode === "edit" ? this.$t("app.actions.save") : this.$t("app.actions.add");
    },
    selectOptions() {
      return (Array.isArray(this.form?.option_labels) ? this.form.option_labels : [])
        .map((label) => String(label || "").trim())
        .filter(Boolean)
        .map((label) => ({ value: label, label }));
    },
  },
};
</script>
